import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";

import { SubjectBasicInformationDto, SubjectDto } from "../../../../interfaces";

type TProps = {
  subjects: SubjectBasicInformationDto[];
  show: boolean;
  onCloseClick: (event: any) => void;
};
export const StudentsSubjectsModal: React.FC<TProps> = ({
  subjects,
  show,
  onCloseClick,
}) => {
  //#region hooks
  const { t, i18n } = useTranslation();
  //#endregion

  //#region internal states
  const [groupedSubjects, setGroupedSubjects] = useState<any>();
  //#endregion

  //#region handlers
  const onClose = () => {
    onCloseClick(!show);
  };

  const groupSubjectsByCourseAndGrade = (
    subjects: SubjectBasicInformationDto[]
  ) => {
    const grouped: {
      [courseId: string]: { [gradeId: string]: SubjectBasicInformationDto[] };
    } = {};

    subjects.forEach((subject) => {
      if (!grouped[subject.courseId]) {
        grouped[subject.courseId] = {};
      }
      if (!grouped[subject.courseId][subject.gradeId]) {
        grouped[subject.courseId][subject.gradeId] = [];
      }
      grouped[subject.courseId][subject.gradeId].push(subject);
    });
    return grouped;
  };

  //#endregion

  //#region effects
  useEffect(() => {
    setGroupedSubjects(groupSubjectsByCourseAndGrade(subjects));
  }, [subjects]);
  //#endregion

  return (
    <React.Fragment>
      <ToastContainer />
      <Modal
        size="lg"
        id="subjects"
        isOpen={show}
        toggle={() => {
          onClose();
        }}
        scrollable
      >
        <ModalHeader
          className="p-3"
          toggle={() => {
            onClose();
          }}
        >
          {t("subjects")} {`(${subjects.length})`}
        </ModalHeader>
        <ModalBody>
          <Row>
            {groupedSubjects &&
              Object.entries(groupedSubjects).map(([courseId, grades]: any) => (
                <div key={courseId}>
                  {Object.entries(grades).map(([gradeId, subjects]: any) => (
                    <div key={gradeId}>
                      <Row
                        style={{
                          border: "solid 1px grey",
                          borderRadius: 10,
                          marginBottom: 10,
                          paddingTop: 10,
                          paddingBottom: 10,
                          paddingLeft: 5,
                          paddingRight: 5,
                        }}
                      >
                        <h4 className="grade-title">
                          {grades[Object.keys(grades)[0]][0].course[
                            i18n.language === "ar" ? "ar" : "en"
                          ] || "Course Title"}
                          {" - "}
                          {subjects[0].grade?.en || "Grade Title"}
                        </h4>
                        {subjects.map(
                          (
                            subject: SubjectBasicInformationDto,
                            index: number
                          ) => (
                            <Col
                              xs={6}
                              sm={6}
                              lg={3}
                              className="py-2"
                              key={subject.id}
                            >
                              <Row>
                                <Col className="d-flex justify-content-center">
                                  <div className="team-profile-img">
                                    <div className="avatar-lg img-thumbnail rounded-circle flex-shrink-0">
                                      {subject.imagePath != null ? (
                                        <img
                                          src={subject.imagePath}
                                          alt=""
                                          className="img-fluid d-block rounded-circle"
                                        />
                                      ) : (
                                        <div className="avatar-title text-uppercase border rounded-circle bg-light text-primary">
                                          {subject?.name?.en.charAt(0) +
                                            subject?.name?.en
                                              .split(" ")
                                              .slice(-1)
                                              .toString()
                                              .charAt(0)}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <div className="text-center">
                                    <div className="team-content pt-2">
                                      <h3 className="fs-16 mb-1">
                                        {i18n.language === "ar"
                                          ? subject.name?.ar
                                          : subject.name?.en}
                                      </h3>
                                    </div>
                                    <div className="team-content pt-1">
                                      <h6 className="fs-12 mb-1">
                                        {new Date(
                                          subject.startAt
                                        ).toLocaleDateString()}{" "}
                                        -{" "}
                                        {new Date(
                                          subject.endAt
                                        ).toLocaleDateString()}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          )
                        )}
                      </Row>
                    </div>
                  ))}
                </div>
              ))}
          </Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};
